import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';

import { fetchMe } from 'redux/users/actions';
import { clearPatchMessageSettingsStatus } from 'redux/anonymous-messages/actions';
import { clearPatchUser } from 'redux/settings/actions';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import AnonymousMessagesSwitcher
  from 'components/dashboard/anonymous-messages-content/AnonymousMessagesSwitcher';
import AnonymousMessagesList
  from 'components/dashboard/anonymous-messages-content/AnonymousMessagesList';
import DirectMesssageAppearence
  from 'components/dashboard/anonymous-messages-content/DirectMesssageAppearence';

import './AnonymousMessagesPageContent.css';

class AnonymousMessagesPageContent extends Component {
  static propTypes = {
    me: PropTypes.object,
    patchUserSuccess: PropTypes.object,
    patchAnonymousMessageSuccess: PropTypes.object,
    patchUserError: PropTypes.object,
    fetchMe: PropTypes.func,
    clearPatchUser: PropTypes.func,
    clearPatchMessageSettingsStatus: PropTypes.func,
  };
  static defaultProps = {
    me: null,
    patchUserSuccess: null,
    patchAnonymousMessageSuccess: null,
    patchUserError: null,
    fetchMe: null,
    clearPatchUser: null,
    clearPatchMessageSettingsStatus: null,
  };

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.patchUserSuccess &&
        prevProps.patchUserSuccess !== this.props.patchUserSuccess
      ) ||
      (!prevProps.patchAnonymousMessageSuccess &&
        prevProps.patchAnonymousMessageSuccess !== this.props.patchAnonymousMessageSuccess
      )
      ) {
      this.props.fetchMe();
      setTimeout(() => {
        this.props.clearPatchUser();
        this.props.clearPatchMessageSettingsStatus();
      }, 500);
    }
  }
  render() {
    const { me } = this.props;

    return (
      <Translation>
        {(t) => (
          <div className="dashboard-messages-page-content__component">
            <DashboardFormSection
              header={t("MESSAGES")}
              className="dashboard-messages-section"
            >
              <div className="messages-switcher">
                <AnonymousMessagesSwitcher />
              </div>

              {me && me.messages_is_active &&
                <div className="direct-message-appearence">
                  <DirectMesssageAppearence id={me.message_settings.id} />
                </div>
              }
            </DashboardFormSection>

            <div className="messages-list">
              <AnonymousMessagesList />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
    patchUserError: state.settingsReducer.patchUserError,
    patchAnonymousMessageSuccess: state.anonymousMessagesReducer.patchAnonymousMessageSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    clearPatchUser,
    clearPatchMessageSettingsStatus,
  },
)(AnonymousMessagesPageContent);
